import React from 'react';
import { Button } from '@mui/material';

export default function ReusableButton({ label, onClick, disabled, buttonType, ...props }) {
    return (
        <Button 
            variant="contained" 
            onClick={onClick} 
            disabled={disabled} 
            sx={{ 
                backgroundColor: "#001B2B", 
                "&:hover": { backgroundColor: "#00324D" }, 
                textTransform: "none",
                ...props.sx 
            }}
            {...props}
        >
            {label}
        </Button>
    );
}
